notifications-items-to-person-in-charge-schedule-changed
  a.media(href="{opts.href}")
    i.feather.icon-clock.bg-c-blue
    .media-body(class="{unread: opts.unread}")
      h5.notification-title { opts.title }
      p.notification-msg { opts.content }
      span.notification-time { ago() }
  script(type="typescript").
    this.mixin('notifications.items.item');
